import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewUpdate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 188,
	height: 116,
	viewBox: "0 0 188 116",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.74669 55.6139L95.6419 7.53354L184.064 49.4902C190.222 53.8888 187.125 61.7176 185.693 62.5566L101.005 113.535C95.5182 116.753 88.7194 116.744 83.242 113.508L5.54894 64.9417C1.95325 62.8173 2.06411 57.5795 5.74669 55.6109V55.6139Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M181.54 48.6354L184.929 52.0243L184.551 59.9288L183.446 63.0091L146.158 85.1466",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.12319 50.7889L0.780476 51.9065C-0.855054 57.6854 1.66254 63.6475 3.31656 65.5352L3.55627 65.8079L59.4161 97.0162L62.1001 92.3351L1.43472 50.1892L1.12319 50.7889Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.49938 47.9702L88.885 2.30199C91.6987 0.797795 95.0816 0.812782 97.8833 2.34395L183.35 49.0579C185.795 50.3943 185.846 53.8851 183.446 55.2935L100.253 104.099C94.767 107.317 87.9681 107.308 82.4907 104.072L3.30162 57.3041C-0.294065 55.1796 -0.183206 49.9419 3.49938 47.9732V47.9702Z",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.353 32.1012L131.413 61.9723C131.488 62.5237 131.059 63.0151 130.502 63.0151C130.068 63.0151 129.69 62.7095 129.603 62.284L123.754 34.2046",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.2609 56.3451L88.8669 86.4471C88.8969 87.0044 88.4294 87.4568 87.8721 87.4119C87.4376 87.3759 87.0871 87.0403 87.0361 86.6089L83.5004 58.143",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.1086 39.9219L82.161 65.1906L136.441 34.3067L93.0799 12.7805L39.1086 39.9219Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.0447 36.1374L44.9846 66.0086C44.9097 66.5599 45.3382 67.0513 45.8955 67.0513C46.33 67.0513 46.7075 66.7457 46.7944 66.3202L52.6434 38.2409",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.9828 38.6663L82.0352 63.935L136.315 33.051L92.9541 11.5248L38.9828 38.6663Z",
			fill: "#D9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.7353 34.2885L79.9856 38.5074C80.3212 39.1337 81.1003 39.3734 81.7265 39.0378L88.7591 35.2863C89.7419 34.7619 89.64 33.3236 88.5973 32.9401L83.4764 31.0673L77.7353 34.2885Z",
			fill: "#B4B6BB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.9828 38.6663L39.1086 39.9218L53.3655 48.2878L54.3693 47.7844L38.9828 38.6663Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.315 33.051L136.441 34.3065L121.744 42.6425L125.507 39.5052L136.315 33.051Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.5907 14.6291L66.5767 37.3808C66.9363 39.0169 68.7551 39.8649 70.2383 39.0858L94.9167 26.1143C95.9385 25.578 96.4689 24.4184 96.2082 23.2947L91.1592 1.52283C90.8866 0.345239 89.5951 -0.278013 88.5014 0.240365L62.6304 12.5136C61.8334 12.8912 61.4019 13.7691 61.5907 14.6321V14.6291Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.6899 59.1947C83.5246 59.1947 85.8227 58.1925 85.8227 56.9563C85.8227 55.7202 83.5246 54.718 80.6899 54.718C77.8551 54.718 75.557 55.7202 75.557 56.9563C75.557 58.1925 77.8551 59.1947 80.6899 59.1947Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.7615 49.9571V56.5522L84.4863 56.6721V49.9571",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.582 51.7999C82.6919 51.7999 84.4024 51.0085 84.4024 50.0321C84.4024 49.0557 82.6919 48.2642 80.582 48.2642C78.472 48.2642 76.7615 49.0557 76.7615 50.0321C76.7615 51.0085 78.472 51.7999 80.582 51.7999Z",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M80.6239 58.0984C82.8233 58.0984 84.6062 57.2734 84.6062 56.2556C84.6062 55.2379 82.8233 54.4128 80.6239 54.4128C78.4246 54.4128 76.6417 55.2379 76.6417 56.2556C76.6417 57.2734 78.4246 58.0984 80.6239 58.0984Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M84.507 51.7478C84.5072 51.7477 84.5073 51.7477 84.2915 51.3534C84.0756 50.9592 84.0758 50.9591 84.0759 50.959L84.0763 50.9588L84.0772 50.9583L84.0795 50.9571L84.0863 50.9534C84.0918 50.9505 84.0991 50.9467 84.1082 50.942C84.1263 50.9327 84.1515 50.9202 84.1827 50.9054C84.2449 50.876 84.3323 50.8372 84.4364 50.7985C84.6374 50.7236 84.9326 50.6364 85.2402 50.6362C85.5548 50.6359 85.9381 50.7298 86.2043 51.0804C86.4567 51.4128 86.5309 51.884 86.4705 52.4664M84.507 51.7478L84.5068 51.748ZM84.5068 51.748L84.5065 51.7481ZM84.5065 51.7481C84.5063 51.7482 84.5062 51.7483 84.5062 51.7483ZM84.5062 51.7483L84.5078 51.7474ZM84.5078 51.7474C84.5097 51.7464 84.5133 51.7445 84.5185 51.7418ZM84.5185 51.7418C84.5289 51.7365 84.5455 51.7282 84.5673 51.7179ZM84.5673 51.7179C84.6111 51.6972 84.6746 51.669 84.7501 51.6409ZM84.7501 51.6409C84.9085 51.5819 85.0879 51.5352 85.241 51.5351ZM85.241 51.5351C85.3871 51.535 85.4506 51.5742 85.4884 51.624ZM85.4884 51.624C85.5399 51.6918 85.6268 51.888 85.5763 52.3738ZM85.5763 52.3738L85.5763 52.3739ZM85.5763 52.3739C85.4743 53.3607 85.0064 54.0343 84.5592 54.4669ZM84.5592 54.4669C84.3346 54.6841 84.1164 54.839 83.9561 54.9387ZM83.9561 54.9387C83.8761 54.9884 83.8113 55.0239 83.7683 55.0462ZM83.7683 55.0462C83.7468 55.0573 83.7309 55.0651 83.7213 55.0697ZM83.7213 55.0697C83.7164 55.072 83.7132 55.0735 83.7117 55.0741ZM83.7117 55.0741L83.7113 55.0744L83.7108 55.0746L83.7108 55.0746C83.7108 55.0746 83.7111 55.0744 83.7117 55.0741Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M81.4898 50.6339C80.2673 51.1283 78.82 50.7508 78.0949 49.6511C77.7204 49.0848 77.5376 48.3297 77.9061 47.3678C78.2747 46.406 79.1706 45.2943 80.0845 44.2246C82.2719 41.6657 82.4307 39.7929 82.4307 39.7929C82.4307 39.7929 83.4165 43.1429 81.0524 47.2809C80.0156 49.0938 83.2008 49.9417 81.4898 50.6339Z",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.938 13.6582L76.8274 29.4673L86.7395 24.8258L82.976 9.14265L72.938 13.6582Z",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M82.8313 18.8096C82.8973 18.9614 82.8277 19.1379 82.6759 19.2038L76.9049 21.7118C76.7531 21.7778 76.5766 21.7082 76.5106 21.5565C76.4447 21.4047 76.5142 21.2282 76.666 21.1622L82.4371 18.6542C82.5889 18.5883 82.7654 18.6578 82.8313 18.8096Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M83.3347 20.3136C83.4007 20.4654 83.3312 20.6419 83.1794 20.7079L77.4054 23.2189C77.2536 23.2849 77.0771 23.2153 77.0111 23.0636C76.9451 22.9118 77.0146 22.7353 77.1664 22.6693L82.9404 20.1583C83.0922 20.0923 83.2687 20.1618 83.3347 20.3136Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M81.6056 22.8324C81.6756 22.9824 81.6107 23.1607 81.4608 23.2307L77.6973 24.9866C77.5473 25.0565 77.369 24.9917 77.299 24.8417C77.2291 24.6917 77.2939 24.5134 77.4439 24.4435L81.2074 22.6876C81.3573 22.6176 81.5356 22.6825 81.6056 22.8324Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.1886 17.8772C80.3454 17.8772 81.2831 16.9394 81.2831 15.7827C81.2831 14.6259 80.3454 13.6882 79.1886 13.6882C78.0318 13.6882 77.0941 14.6259 77.0941 15.7827C77.0941 16.9394 78.0318 17.8772 79.1886 17.8772Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M80.1219 14.4969C80.1966 14.5325 80.2283 14.6219 80.1927 14.6966L79.182 16.818L78.1485 16.218C78.0769 16.1765 78.0526 16.0848 78.0941 16.0132C78.1357 15.9417 78.2274 15.9173 78.2989 15.9589L79.0513 16.3957L79.9222 14.5677C79.9578 14.4931 80.0472 14.4613 80.1219 14.4969Z",
			fill: "#8CD1FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M89.1396 8.6392L96.9243 4.74986L99.7529 6.63461L102.701 18.1917L93.032 22.3208L89.1396 8.6392Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .8,
			d: "M57.4107 24.2476L65.1954 20.3583L68.024 22.243L70.9724 33.8001L61.303 37.9292L57.4107 24.2476Z",
			fill: "#0D97F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.171 82.3238C109.171 82.3238 104.298 80.1574 103.486 81.1043C102.674 82.0511 105.788 85.9764 108.089 86.3839C110.39 86.7914 109.578 88.008 111.067 88.2777C112.557 88.5473 113.369 88.2776 113.369 87.3308C113.369 86.3839 112.961 83.2706 112.961 83.2706",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.053 79.0728C119.053 79.0728 111.879 77.9911 112.961 79.75C114.043 81.5089 116.752 81.1044 117.698 82.8633C118.645 84.6222 120.542 85.572 122.301 84.757L122.978 84.0798L122.166 80.559",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.923 47.8053C105.923 47.8053 106.33 58.6343 107.004 65.4032C107.681 72.172 108.628 83.4056 108.628 83.4056C108.628 83.4056 110.795 87.196 113.231 86.1143C113.231 86.1143 113.096 65.4032 113.908 60.3962C113.908 60.3962 114.576 66.0594 115.802 71.2252C117.081 76.6067 117.639 81.8385 117.639 81.8385C117.639 81.8385 121.759 83.6782 122.571 82.5935C122.571 82.5935 121.351 73.5234 120.812 68.7861C120.272 64.0488 121.681 44.8029 121.681 44.8029L118.241 43.2028L105.923 47.8053Z",
			fill: "#F07C78"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.059 7.43776C108.059 7.43776 106.839 6.76057 106.3 10.9585C105.758 15.1535 106.03 17.7274 107.382 17.7274C108.733 17.7274 109.413 17.4577 109.413 18.6743C109.413 19.8908 109.278 20.8407 109.278 20.8407C109.278 20.8407 114.475 22.0712 114.811 19.725L114.558 18.1349C114.558 18.1349 115.361 18.1739 116.683 14.773C118.004 11.372 118.214 5.67887 114.966 5.4092C111.718 5.13952 106.414 5.37324 106.83 6.47592C107.25 7.5756 108.062 7.44076 108.062 7.44076L108.059 7.43776Z",
			fill: "#FFBD5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.059 20.8406C108.059 20.8406 113.006 23.4595 115.505 21.6526C117.21 20.4181 115.679 18.5573 115.679 18.5573C115.679 18.5573 120.182 17.9551 121.402 20.2563C122.621 22.5575 120.254 32.1431 120.928 35.526C121.606 38.9089 123.071 43.9609 122.936 50.3223C122.936 50.3223 120.65 52.6505 118.483 52.3808L116.994 48.1858L116.452 52.9231C116.452 52.9231 109.383 54.4603 104.119 50.9844C104.119 50.9844 104.403 41.4169 105.353 40.0625C106.3 38.7082 105.731 31.3999 105.323 28.6942C104.916 25.9854 107.247 21.2481 108.062 20.8406H108.059Z",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.6862 19.4863C98.6862 19.4863 96.0763 18.6803 96.8254 15.5071C97.2689 13.6194 94.4073 11.2612 95.8666 11.6687C97.3228 12.0792 97.4157 13.1909 98.3476 13.4126C99.2795 13.6374 100.631 12.7804 101.488 16.6667L99.0207 19.9875L98.6862 19.4863Z",
			fill: "#FFBD5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.161 21.78C107.161 21.78 107.608 20.3327 109.388 20.6653C111.171 20.9979 114.773 21.8048 114.662 18.9103C114.662 18.9103 115.331 17.7956 116.22 19.0211C117.11 20.2467 115.848 23.449 112.618 22.8917C109.388 22.3343 107.161 21.777 107.161 21.777V21.78Z",
			fill: "#FFBD5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.649 22.9681C108.649 22.9681 103.292 18.2068 101.326 15.9835C101.326 15.9835 99.714 16.9004 98.7132 20.3852C97.9221 23.1419 106.093 28.4395 106.093 28.4395L108.649 22.9711V22.9681Z",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.878 5.97238C106.878 5.97238 105.988 6.97319 107.768 7.97698C109.548 8.98078 109.138 9.69393 109.662 10.7606C109.881 11.2071 109.773 13.0978 109.773 13.0978L110.552 12.8761C110.552 12.8761 110.663 11.318 111.553 12.2079C112.443 13.0978 111.999 17.5535 113.222 18.2217C114.447 18.8899 117.306 18.0479 117.974 12.7023C118.555 8.06089 117.423 5.58285 114.112 5.08245C110.438 4.52512 106.872 5.63978 106.872 5.97238H106.878Z",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.799 51.0294C100.799 51.0294 100.145 52.971 100.211 53.9688C100.277 54.9696 100.238 56.0873 101.455 55.8955C102.668 55.7038 102.728 54.9187 103.441 53.867C104.155 52.8152 103.726 51.3919 103.726 51.3919L100.802 51.0264L100.799 51.0294Z",
			fill: "#FFBD5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.355 21.8025C107.355 21.8025 104.128 21.8744 103.355 27.0582C102.579 32.242 103.415 39.9187 103.415 39.9187L100.226 50.8437L104.523 51.6766C104.448 51.7905 107.732 41.5758 108.607 39.1307C108.946 38.1868 110.627 25.7158 110.627 25.7158",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.668 53.5284L103.313 55.7607C103.313 55.7607 103.639 58.3406 101.931 57.4267C100.22 56.5128 100.268 53.9659 100.268 53.9659",
			fill: "#FFBD5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.792 46.4419L140.27 56.2851C140.486 57.2979 141.187 58.1369 142.143 58.5324C143.453 59.0718 145.607 59.4284 148.777 58.4096C149.808 58.08 150.584 57.217 150.839 56.1653L153.083 46.8464",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M145.487 50.9965C149.681 50.9965 153.08 49.1384 153.08 46.8464C153.08 44.5544 149.681 42.6964 145.487 42.6964C141.294 42.6964 137.894 44.5544 137.894 46.8464C137.894 49.1384 141.294 50.9965 145.487 50.9965Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M143.09 47.5897C143.09 47.5897 145.766 43.0381 149.257 41.2373C155.049 38.2469 154.303 27.2231 158.411 27.4119C158.411 27.4119 155.795 30.5881 157.29 34.8849C158.785 39.1818 155.666 45.3214 150.434 44.2007C145.202 43.0801 143.09 47.5897 143.09 47.5897Z",
			fill: "#080E49"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M142.97 46.0106C142.97 46.0106 148.948 42.0883 147.642 36.2962C146.335 30.5042 141.664 27.7025 141.664 27.7025C141.664 27.7025 140.094 30.2794 142.524 34.3905C144.954 38.5016 144.84 44.3326 142.973 46.0136L142.97 46.0106Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.628 38.061C149.628 38.061 153.925 30.0277 150.374 27.4118C146.824 24.7959 142.341 22.1801 144.022 19.5642C145.703 16.9483 144.022 18.6293 144.022 18.6293C144.022 18.6293 140.1 24.0468 143.647 27.4118C147.198 30.7738 150.56 33.2039 149.625 38.061H149.628Z",
			fill: "#0E177A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M143.102 41.8035C143.102 41.8035 144.999 37.3898 139.207 36.6437C133.415 35.8976 134.883 44.0479 134.883 44.0479C134.883 44.0479 138.245 37.1351 143.105 41.8065L143.102 41.8035Z",
			fill: "#080E49"
		})
	]
});
export default SvgNewUpdate;
